export default __webpack_public_path__ + "static/media/laliga.b56af416.svg";